import type { AreaId, SubAreaId } from '@shared/brand';

/**
 * A quién busca la búsqueda.
 *
 * La regla no es nueva: es la del calendario. Quien ve su área entera busca en
 * ella, y quien sólo ve su sub área busca en la suya. Lo que faltaba era la
 * tercera pieza, y es lo reportado: **para un `global` el área en la que busca es
 * la que tiene en foco**, no la suya. Calendario, reportes, personas y bitácora
 * ya seguían el selector; la búsqueda se quedó mirando `session.areaId`, así que
 * el buscador de arriba contestaba sobre un área distinta de la que la pantalla
 * de al lado estaba enseñando.
 *
 * **Y el estrechamiento por sub área sólo vale en la propia.** Un `global`
 * mirando MKT no tiene sub área ahí: aplicarle la suya —de Tecnología— filtraría
 * por un identificador que en esa área no existe y devolvería cero personas, que
 * es la peor forma de fallar porque se lee como «no hay nadie».
 */
export interface PeopleScope {
  readonly areaId: AreaId;
  readonly ownAreaId: AreaId;
  readonly ownSubAreaId: SubAreaId | null;
  /** Si sus permisos le dejan ver el área entera y no sólo su sub área. */
  readonly canSeeArea: boolean;
}

export interface PeopleFilter {
  readonly areaId: AreaId;
  readonly status: 'active';
  readonly subAreaId?: SubAreaId;
}

export const peopleFilterFor = (scope: PeopleScope): PeopleFilter => {
  const enSuArea = scope.areaId === scope.ownAreaId;

  if (scope.canSeeArea || !enSuArea || scope.ownSubAreaId === null) {
    return { areaId: scope.areaId, status: 'active' };
  }
  return { areaId: scope.areaId, status: 'active', subAreaId: scope.ownSubAreaId };
};
